// Configuración de estados para proyectos y tareas
// Este diccionario permite convertir entre valores del backend y textos del frontend

export const STATUS_CONFIG = {
  backlog: {
    value: 'backlog',
    label: 'En Backlog',
    color: 'purple',
    bgColor: 'bg-purple-100 dark:bg-purple-900',
    textColor: 'text-purple-800 dark:text-purple-200'
  },
  pending: {
    value: 'pending',
    label: 'Pendiente',
    color: 'yellow',
    bgColor: 'bg-yellow-100 dark:bg-yellow-900',
    textColor: 'text-yellow-800 dark:text-yellow-200'
  },
  progress: {
    value: 'progress',
    label: 'En progreso',
    color: 'green',
    bgColor: 'bg-green-100 dark:bg-green-900',
    textColor: 'text-green-800 dark:text-green-200'
  },
  completed: {
    value: 'completed',
    label: 'Completado',
    color: 'blue',
    bgColor: 'bg-blue-100 dark:bg-blue-900',
    textColor: 'text-blue-800 dark:text-blue-200'
  },
  cancelled: {
    value: 'cancelled',
    label: 'Cancelado',
    color: 'red',
    bgColor: 'bg-red-100 dark:bg-red-900',
    textColor: 'text-red-800 dark:text-red-200'
  },
  // Alias para 'in progress' que viene de la API de tareas
  'in progress': {
    value: 'progress',
    label: 'En progreso',
    color: 'green',
    bgColor: 'bg-green-100 dark:bg-green-900',
    textColor: 'text-green-800 dark:text-green-200'
  }
};

// Función para obtener el label (texto para mostrar en el frontend)
export const getStatusLabel = (backendValue) => {
  const status = STATUS_CONFIG[backendValue];
  return status ? status.label : backendValue;
};

// Función para obtener el valor del backend
export const getStatusValue = (label) => {
  const entry = Object.entries(STATUS_CONFIG).find(([_, config]) => config.label === label);
  return entry ? entry[1].value : label;
};

// Función para obtener la configuración completa del estado
export const getStatusConfig = (backendValue) => {
  return STATUS_CONFIG[backendValue] || {
    value: backendValue,
    label: backendValue,
    color: 'gray',
    bgColor: 'bg-gray-100 dark:bg-gray-900',
    textColor: 'text-gray-800 dark:text-gray-200'
  };
};

// Array de todos los estados disponibles para selects
export const STATUS_OPTIONS = [
  { value: 'backlog', label: 'En Backlog' },
  { value: 'pending', label: 'Pendiente' },
  { value: 'progress', label: 'En progreso' },
  { value: 'completed', label: 'Completado' },
  { value: 'cancelled', label: 'Cancelado' }
];

// Función para obtener el color del badge de estado
export const getStatusColorClasses = (backendValue) => {
  const status = getStatusConfig(backendValue);
  return `${status.bgColor} ${status.textColor}`;
};

























